import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface PersonalProps {
    onDataChange: (data: any) => void
    studDet: (data: any) => void
    onNext: () => void
    formcheck: () => void
}

const Personal: React.FC<PersonalProps> = ({ onDataChange, studDet, onNext, formcheck }) => {
    let initialFormState;
    if (studDet != null) {
        initialFormState = {
            userId:studDet[0].coreUserId,firstname: studDet[0].coreUserFirstName, lastname: studDet[0].coreUserLastName, dob: studDet[0].coreUserDOB, gender: studDet[0].coreUserGender,
            parentname: studDet[0].coreUserParentName, nationality: studDet[0].coreUserNationality, address: studDet[0].coreUserAddress,
            state: studDet[0].coreUserState, city: studDet[0].coreUserCity, pincode: studDet[0].coreUserPincode, email: studDet[0].coreUserEmail, phonenum: studDet[0].coreUserPhone
        }
    } else {
        initialFormState = {
            firstname: '', lastname: '', dob: '', gender: '', parentname: '', nationality: '', address: '', state: '', city: '',
            pincode: '', email: '', phonenum: ''
        }
    }

    const [formData, setFormData] = useState(initialFormState);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const updatedData = { ...formData, [name]: value };
        setFormData(updatedData);
        onDataChange(updatedData); // Send data to AddStudent
    };

    useEffect(() => {
        if (studDet != null) {
            setFormData(initialFormState);
            onDataChange(initialFormState);
        }
    }, [])

    return (
        <form ref={formcheck}>
            <div className="card card-tableset" style={{ padding: "10px" }}>
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-4">
                                    <label className="form-label">First Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="firstname"
                                        required
                                        value={formData.firstname}
                                        onChange={handleChange}
                                        placeholder="Student First Name" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Last Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="lastname"
                                        required
                                        value={formData.lastname}
                                        onChange={handleChange}
                                        placeholder="Student Last Name" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Date of Birth</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="dob"
                                        required
                                        value={formData.dob}
                                        onChange={handleChange}
                                        placeholder="Student DOB" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Gender</label>
                                    <div className="radio">
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input default-check me-2"
                                                type="radio"
                                                name="gender"
                                                id="inlineRadio1"
                                                value="M"
                                                checked={formData.gender === "M"}
                                                onChange={handleChange}
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="inlineRadio1"
                                            >
                                                Male
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input default-check me-2"
                                                type="radio"
                                                name="gender"
                                                id="inlineRadio2"
                                                value="F"
                                                checked={formData.gender === "F"}
                                                onChange={handleChange}
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="inlineRadio2"
                                            >
                                                Female
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Parent Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="parentname"
                                        value={formData.parentname}
                                        onChange={handleChange}
                                        placeholder="Student Parent Name" />
                                </div>
                                <div className="col-lg-4">
                                    <div className="input-space">
                                        <label className="form-label">Nationality</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            name="nationality"
                                            value={formData.nationality}
                                            onChange={handleChange}
                                            placeholder="Student Nationality" />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <label className="form-label">Address</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="address"
                                        value={formData.address}
                                        onChange={handleChange}
                                        placeholder="Address" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">State</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="state"
                                        value={formData.state}
                                        onChange={handleChange}
                                        placeholder="State" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">City</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="city"
                                        value={formData.city}
                                        onChange={handleChange}
                                        placeholder="City" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Pincode</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="pincode"
                                        value={formData.pincode}
                                        onChange={handleChange}
                                        placeholder="Pincode" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Email</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="Email" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Phone Number</label>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        maxLength={10}
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="phonenum"
                                        value={formData.phonenum}
                                        onChange={handleChange}
                                        placeholder="Phone"
                                    />
                                </div>

                                <div className="text-end btn-row" style={{ boxShadow: "none", marginTop: "0px" }}>
                                    {/* <Link className="btn btn-primary me-3 btn-icon" to="#"><i className="feather-arrow-left-circle me-1" /> Back</Link> */}
                                    <Link className="btn btn-secondary btn-icon" to="#" onClick={onNext}>Next <i className="feather-arrow-right-circle ms-1" /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default Personal;